import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-installment';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Installment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getInstallmentlist();
  }


  deleteInstallment = (id) => {
    confirmAlert({
      title: 'Delete Installment',
      message: 'Are you sure to delete the Installment?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteInstallment(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.installmentList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const installmentData = this.props.installmentList.filter((item) => item.Title.toLowerCase().includes(searchVal));
    const columns = [{
      dataField: 'Title',
      text: 'Installment Name'
    }, {
      dataField: 'Terms',
      text: 'Terms'
    }, {
      dataField: 'InterestRate',
      text: 'Interest Rate'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/installment-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteInstallment(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Installment" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-file-alt cardTitle"> Installment</span> */}
                    <SearchBar
                      placeholder="Search by Installment Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <Button
                      className="btn btn-sm btn-secondary ml-3"
                      onClick={() => this.props.history.push('/installment-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={installmentData}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Installment.defaultProps = {
  tableLoading: false,
  installmentList: null,
  getInstallmentlist: null,
  deleteInstallment: null
};

Installment.propTypes = {
  tableLoading: PropTypes.bool,
  installmentList: PropTypes.array,
  getInstallmentlist: PropTypes.func,
  deleteInstallment: PropTypes.func
};

const mapStateToProps = ({ installment }) => ({
  tableLoading: installment.tableLoading,
  installmentList: installment.installmentList
});

const mapDispatchToProps = (dispatch) => ({

  getInstallmentlist: () => dispatch(actions.fetchInstallment()),
  deleteInstallment: (id) => dispatch(actions.deleteInstallment(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Installment);
